(function() {
angular.module('app.ui.form.ctrls', ['pascalprecht.translate', 'angularFileUpload', 'angular.filter', 'ngSlider', 'ngCookies', 'ngAnimate', 'ngSanitize', 'angularSpinner', 'angular-clipboard', 'ui.nested.combobox']).config(function($translateProvider) {
    $translateProvider.useStaticFilesLoader({
      prefix: 'i18n/resourceBundle-',
      suffix: '.json'
    });
    $translateProvider.preferredLanguage('en');
  })
}());


// WEBPACK FOOTER //
// ./scripts/form/Form.js